import React from 'react';

import FieldBirthday from '../commons/FieldBirthday';
import FieldText from '../commons/FieldText';

const GeneralMoralData = () => {
  return (
    <div>
      <h3>Datos generales</h3>
      <hr className="solid" />
      <div className="field-row">
        <FieldText
          maxLength={100}
          label="Nombre completo o razón social"
          name="socialReason"
          required />
        <FieldText
          maxLength={13}
          label="RFC"
          name="moralRfc"
          required />
      </div>
      <div className="field-row">
        {/*
          For the future:
          * this name was chosen because the original design considered this field for the
          * Legal Representative (a real person) of the company buying the insurance.
          * At a later date, close to release, it was noted from the client
          * that this date was not about the person who represents the company
          * but rather the formation (constitution, creation) of this company.
          * But for time reasons, the form's name of the field
          * (the value used by formik and the rest of the app) was not changed.
        */}
        <FieldBirthday
          label="Fecha de constitución de la empresa"
          name="representativeBirthdate"
          className="field -half-input"
          required />
      </div>
    </div>
  );
};

export default GeneralMoralData;
